module.exports = __webpack_public_path__ + "img/5.d6c2e1ff.png";